import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { SHAPE_TYPES } from '../constants';

/**
 * A fixed-position ghost element that follows the cursor while the user drags
 * an element from the palette onto the canvas. Rendered at the top level so it
 * appears above all panels.
 */
export function DragGhost({ ghost }) {
  if (!ghost) return null;
  const shape = SHAPE_TYPES[ghost.type] || SHAPE_TYPES.rect;
  return (
    <Box
      sx={{
        position: 'fixed',
        left: ghost.x - 40,
        top:  ghost.y - 30,
        width: 80, height: 60,
        pointerEvents: 'none',
        zIndex: 9999,
        borderRadius: 2,
        border: `2px dashed ${shape.color}`,
        background: alpha(shape.color, 0.15),
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: shape.color,
        boxShadow: `0 4px 20px ${alpha(shape.color, 0.3)}`,
      }}
    >
      {shape.icon}
    </Box>
  );
}